var protobuf = require("protobufjs");
import axios from 'axios'
const getDefaultState = () => {
    return {
        notification: false,
        timer: false,
    }
  }

export const state = getDefaultState()

export const getters = {
    notificationToShow(state) {
        return state.notification;
    }
}

export const mutations = {
    showNotification(state, data) {
        state.notification = data;
    }
}

export const actions = {
    showNotification(state, data) {
        let {
            timeout = 2500,
            text = "N/A",
        } = data;
        state.commit("showNotification", {
            text: text,
        });
        clearInterval(state.timer);
        state.timer = setTimeout(() => {
            state.commit("showNotification", false);
        }, timeout)        
    }
}


export default {
    namespaced: false,
    state,
    getters,
    actions, 
    mutations
  }